import React, { Component } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    MemoryRouter,
    Link,
    Redirect
    // useHistory
} from "react-router-dom";
import './AdditionalPackage.css';
import Quiz from './Quiz.json';
import moment from 'moment';
import axios from 'axios';
import Loading from '../../Components/Loading/Loading';
import Card from 'react-credit-cards';
import {
    formatCreditCardNumber,
    formatCVC,
    formatExpirationDate,
    formatFormData,
} from '../../Components/utils';
import 'react-credit-cards/es/styles-compiled.css';
import NumberFormat from 'react-number-format';
import Swal from 'sweetalert2';
import withReactContent from "sweetalert2-react-content";

import successIcon from "../../images/successicon.png";
import warningSign from "../../images/warning-sign.png";

import InputCVV from './InputCVV';

import { transactionID } from "../../services/helpers";


const MySwal = withReactContent(Swal);

class AdditionalPackageStep extends Component {

    constructor(props) {
        super(props);

        let clientInfo = JSON.parse(localStorage.getItem('clientInfo'));


        //console.log(localStorage.getItem('clientInfo'));
        axios.defaults.headers.common['Authorization'] = "Bearer " + clientInfo.accessToken;
        axios.defaults.headers.common['Content-Type'] = "application/json";

        this.state = {
            clientInfo: clientInfo,
            loading: 0,
            tryLastRechart: 0,

            currentStep: 0,
            chooseNumber: {
                homeHistory: [],
                bundleInfo: []
            },
            chooseAmount: [],
            chooseCreditcard: [],
            createRecharge: {
                msisdn: clientInfo.number,
                number: 0,
                amount: 0,
                bundleId: '',
                paymentType: '',
                paymentId: 0,
                paymentFlag: '',
                paymentLastNumber: '',
                scheduledRecharge: 0,
                cvv: 0
            },
            focused: '',
            cardData: {
                type: '',
                name: '',
                number: '',
                expiry: '',
                cvv: '',
                cpf: ''
            },
            lastRecharge: {
                month: '',
                year: '',
                number: '',
                amount: '',
                paymentId: 0,
                paymentFlag: '',
                paymentLastNumber: ''
            },
            redirect: false,
            showProgramBanner: true
        }

        this.changePage = this.changePage.bind(this);
    }

    trocarPlano() {
        // let history = useHistory();
        this.setState({
            createRecharge: {
                ...this.state.createRecharge,
                number: this.state.clientInfo.number
            }
        });
        // useHisthistoryory.push("/step")
        // this.changePage('chooseNumber');


        document.querySelector('.init-troca-de-plano').click();

        // console.log('TROCAR PLANO: ');
    }

    tryAgainLastRechart() {
        let currentMonth = this.state.lastRecharge.month;
        let currentYear = this.state.lastRecharge.year;

        let month = moment(currentMonth, 'MM').subtract(1, 'months').format('MM');
        let year = month === '12' ? moment(currentYear, 'YYYY').subtract(1, 'year').format('YYYY') : moment(currentYear, 'YYYY').format('YYYY');

        this.getLastRechart(year, month);

        this.setState({ tryLastRechart: this.state.tryLastRechart + 1 });
    }

    getLastRechart(year, month) {
        this.setState({
            loading: 1,
            lastRecharge: {
                ...this.state.lastRecharge,
                month: month,
                year: year
            }
        });
        axios.post('https://www.pagtel.com.br/Hub360Correios/v3/topUpHistory', {
            transactionId: transactionID('AAQ'),
            msisdn: this.state.clientInfo.number,
            year: year,
            month: month
        }).then((response) => {
            if (typeof response.data.details !== 'undefined' && response.data.code === 'P00') {
                let output;
                let recharge;
                // console.log(response);
                response.data.details.map((result) => {
                    let oldDate = '';
                    if (result.rechargeStatus === 'Sucesso' && (result.date > oldDate)) {
                        let oldDate = moment(result.date, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
                        output = result;
                    }
                });



                if (!output) {
                    if (this.state.tryLastRechart < 2) this.tryAgainLastRechart();
                    return false;
                }


                recharge = {
                    number: this.formatPhone(this.state.clientInfo.number),
                    amount: output.rechargeValue,
                    paymentMethod: '',
                }

                this.setState({ lastRecharge: recharge, loading: 0 });

            } else {
                if (this.state.tryLastRechart < 2) this.tryAgainLastRechart();
            }

            if (this.state.tryLastRechart === 2) this.setState({ loading: 0 });

        });

    }

    componentDidMount() {

        if (window.location.hash === '#adicional') {
            this.trocarPlano();
            // this.checkBundle()

            return false;
        }


        // this.getLastRechart(moment().format('YYYY'), moment().format('MM'));
        this.queryProgram();
        // this.changePage("chooseNumber");

        let pixStatus = JSON.parse(localStorage.getItem('@pix-data-recharge')) || "";

        if (pixStatus === "") return;

        let pixDetails = JSON.parse(localStorage.getItem('@pix-data')) || "";

        let displayRechargInitial = document.querySelector('.content-recharge-manager');

        if (!pixDetails) return;

        if (displayRechargInitial) displayRechargInitial.classList.add("d-none");

        const newCreateRecharge = {
            ...pixDetails,
            paymentType: "P"
        }

        this.setState({
            pixResponseData: newCreateRecharge,
            createRecharge: newCreateRecharge,
            pixOpen: true,
        })

        localStorage.removeItem('@pix-data-recharge')
    }

    formatReal(int) {
        var tmp = int + '';
        tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
        if (tmp.length > 6)
            tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

        return `R$${tmp}`;
    }

    formatPhone(phone) {
        if(phone !== 0) return phone.length > 11 ? phone.slice(2) : phone;
        return "";
    }

    queryProgram = () => {

        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/queryProgram', {
            transactionId: transactionID('AAR'),
            msisdn: JSON.parse(localStorage.getItem("clientInfo")).number

        }, { headers: { "Authorization": "Bearer " + JSON.parse(localStorage.getItem("clientInfo")).accessToken } }).then((response) => {

            switch (response.data.code) {
                case 'P00':
                    this.setState({ showProgramBanner: false });
                    break;
                case 'P01':
                    this.setState({ showProgramBanner: true });
                    break;
                default:
                    // this.setState({loading: 0});
                    Swal.fire({
                        title: 'Erro!',
                        text: response.data.msg,
                        type: 'error',
                        icon: 'error'
                    })
                    break;
            }

        });
    }

    validCpf = (strCPF) => {
        let Soma;
        let Resto;
        Soma = 0;
        if (strCPF == "00000000000") return false;

        for (let i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
        Resto = (Soma * 10) % 11;

        if ((Resto == 10) || (Resto == 11)) Resto = 0;
        if (Resto != parseInt(strCPF.substring(9, 10))) return false;

        Soma = 0;
        for (let i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
        Resto = (Soma * 10) % 11;

        if ((Resto == 10) || (Resto == 11)) Resto = 0;
        if (Resto != parseInt(strCPF.substring(10, 11))) return false;
        return true;
    }

    handleCheckboxCcheduled = event => {
        this.setState({ createRecharge: { ...this.state.createRecharge, scheduledRecharge: event.target.checked } })
    }
    getValues() {
        axios.post('https://www.pagtel.com.br/Hub360Correios/v1/GetBundles', {
            transactionId: transactionID('AAS'),
            MSISDN: this.state.clientInfo.number
        }).then((response) => {
            //console.log(response);

            this.setState({ chooseAmount: response.data.bundleList, loading: 0 });
            // this.setState({ chooseAmount: response.data.valueList, loading: 0 });
        });
    }

    async checkBundle() {
        let response = await axios.post('https://www.pagtel.com.br/Hub360Correios/v1/checkBundle', {
            transactionId: transactionID('AAT'),
            MSISDN: this.state.clientInfo.number
        })
        if (response.data.code === "01") {
            await Swal.fire({
                title: 'Ops!',
                text: "Você ainda não atingiu 100% do seu Benefício para contratar um pacote adicional !!",
                imageUrl: warningSign,
                confirmButtonColor: '#05416B'
            })
            this.setState({ redirect: true });

        }

    }

    chooseNumber(number) {
        this.setState({ createRecharge: { ...this.state.createRecharge, number: number }, loading: 1 });
        this.getValues();
        this.steps('next');
    }

    chooseAmount(amount, bundleId, note) {
        this.setState({
            createRecharge:
            {
                ...this.state.createRecharge,
                amount: amount,
                bundleId: bundleId,
                note: note
                // details: response.details
            }
            , loading: 0
        });
        // this.setState({
        //     createRecharge: {
        //         ...this.state.createRecharge, amount: response.value, details: [{
        //             "icone": "https://pagtel.com.br/correiosimg/icons/call.png",
        //             "title": "Ligações Ilimitadas",
        //             "description": "Fixo e celular, qualquer operadora de DDD"
        //         },
        //         {
        //             "icone": "https://pagtel.com.br/correiosimg/icons/internet.png",
        //             "title": "Internet sem cortes",
        //             "description": "7 GB de alta velocidade"
        //         }]
        //     }, loading: 0
        // });
        this.steps('next');
        // this.displayCreditCard();
    }

    resetDisplayPaymentMethod() {
        let displayCreditCard = document.querySelector(".choose-creditcard");
        let displayAddCreditCard = document.querySelector(".display-add-card");
        let displayDebitCard = document.querySelector(".choose-debitcard");
        // let displayPix = document.querySelector(".choose-debitcard");

        // let chooseMethod = document.querySelector(".choose-method");

        if (displayCreditCard) displayCreditCard.classList.add("d-none");
        if (displayAddCreditCard) displayCreditCard.classList.add("d-none");
        if (displayDebitCard) displayCreditCard.classList.add("d-none");
        // if (displayPix) displayCreditCard.classList.add("d-none");

        // if (chooseMethod) chooseMethod.classList.remove("d-none");
    }

    choosePaymentMethod(paymentMethod) {
        this.setState({
            createRecharge: {
                ...this.state.createRecharge,
                paymentType: paymentMethod.paymentType,
                paymentId: paymentMethod.paymentID,
                paymentFlag: paymentMethod.flag,
                paymentLastNumber: paymentMethod.digFour
            },
            loading: 0
        });
        this.steps('next');

        this.resetDisplayPaymentMethod();

    }

    validCard() {
        if (this.state.cardData.number === "" || this.state.cardData.number.length < 16) {
            Swal.fire({
                title: 'Erro!',
                text: "Escolha o cartão!",
                type: 'error'
            });
            return false;
        }

        if (this.state.cardData.name === "") {

            Swal.fire({
                title: 'Erro!',
                text: "Escolha o nome do titular!",
                type: 'error'
            });
            return false;
        }

        if (this.state.cardData.expiry === "" || this.state.cardData.expiry.length < 4) {

            Swal.fire({
                title: 'Erro!',
                text: "Escolha a data de vencimento!",
                type: 'error'
            });
            return false;
        }

        if (this.state.createRecharge.amount === 0) {
            Swal.fire({
                title: 'Erro!',
                text: "Escolha o valor da recarga!",
                type: 'error'
            })
            this.setState({ loading: false });
            return false;
        }

        if (this.state.cardData.cvv === "" || this.state.cardData.cvv.length === 0) {
            Swal.fire({
                title: 'Erro!',
                text: "Digite o CVV!",
                type: 'error'
            })
            this.setState({ loading: false });
            return false;
        }

        if (!this.validCpf(this.state.cardData.cpf)) {
            Swal.fire({
                title: 'Erro!',
                text: "CPF inválido!",
                type: 'error'
            })
            this.setState({ loading: false });
            return false;
        }

        return true;
    }

    addDebitcard() {

        if (!this.validCard()) {
            return false;
        };

        this.setState({ loading: 1 });

        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/addCard', {
            transactionId: transactionID('AAU'),
            msisdn: this.state.clientInfo.number,
            paymentType: "D",
            cardNumber: this.state.cardData.number,
            expiration: this.state.cardData.expiry,
            cvv: this.state.cardData.cvv,
            cpf: this.state.cardData.cpf,
            name: this.state.cardData.name

        }).then((response) => {

            this.setState({ loading: 0 });

            switch (response.data.code) {
                case 'P00':

                    let numberCard = this.state.cardData.number;

                    let lastFourNumber = numberCard.substring(numberCard.length - 4);
                    let cardFlag = '';

                    switch (this.state.cardData.number.substring(0, 1)) {
                        case '4':
                            cardFlag = 'Visa';
                            break;
                        case '5':
                            cardFlag = 'Mastercard';
                            break;
                        default:
                            cardFlag = '';
                            break;
                    }

                    let cardText = `${cardFlag} ${lastFourNumber}`;

                    this.setState({
                        createRecharge: {
                            ...this.state.createRecharge,
                            paymentId: response.data.paymentID,
                            paymentFlag: cardFlag,
                            paymentLastNumber: lastFourNumber,
                            paymentType: 'D'
                        },
                        loading: 0
                    });

                    this.steps('next');
                    break;

                default:

                    Swal.fire({
                        title: 'Erro!',
                        text: response.data.msg,
                        type: 'error',
                        icon: 'error'
                    });

                    break;
            }

        });
    }


    displayPix() {
        let chooseCreditcard = document.querySelector(".choose-creditcard");
        let pix = document.querySelector(".display-add-card");

        chooseCreditcard.classList.add("d-none");
        pix.classList.remove("d-none");
        //display-pix
    }
    addCreditcard() {


        if (!this.validCard()) {
            return false;
        };

        this.setState({ loading: 1 });

        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/addCard', {
            transactionId: transactionID('AAV'),
            msisdn: this.state.clientInfo.number,
            paymentType: "C",
            cardNumber: this.state.cardData.number,
            expiration: this.state.cardData.expiry,
            cvv: this.state.cardData.cvv,
            cpf: this.state.cardData.cpf,
            name: this.state.cardData.name

        }).then((response) => {

            switch (response.data.code) {
                case 'P00':
                    this.displayCreditCard();
                    break;

                default:
                    this.setState({ loading: 0 });
                    Swal.fire({
                        title: 'Erro!',
                        text: response.data.msg,
                        type: 'error',
                        icon: 'error'
                    })
                    break;
            }

        });
    }

    displayAddCreditCard() {
        let chooseCreditcard = document.querySelector('.choose-creditcard');
        let addCreditcard = document.querySelector('.display-add-card');

        chooseCreditcard.classList.add('d-none');
        chooseCreditcard.classList.remove('d-block-important');
        addCreditcard.classList.remove('d-none');
        //display-add-card
    }

    displayCancelCreditCard() {
        let chooseCreditcard = document.querySelector('.choose-creditcard');
        let addCreditcard = document.querySelector('.display-add-card');

        chooseCreditcard.classList.remove('d-none');
        chooseCreditcard.classList.add('d-block-important');
        addCreditcard.classList.add('d-none');
        //display-add-card
    }

    displayCreditCard_2() {

        let addCreditcard = document.querySelector('.display-add-card');
        addCreditcard.classList.add('d-none');

    }

    displayDeditCard_2() {
        let addCreditcard = document.querySelector('.choose-debitcard');
        addCreditcard.classList.add('d-none');
    }

    displayCreditCard() {

        this.setState({ loading: 1 });
        let chooseMethod = document.querySelector('.choose-method');
        let chooseCreditcard = document.querySelector('.choose-creditcard');
        let addCreditcard = document.querySelector('.display-add-card');
        chooseMethod.classList.add('d-none');
        chooseCreditcard.classList.remove('d-none');
        chooseCreditcard.classList.add('d-block-important');
        addCreditcard.classList.add('d-none');

        axios.post('https://www.pagtel.com.br/Hub360Correios/v2/GetCard', {
            transactionId: transactionID('AAW'),
            MSISDN: this.state.clientInfo.number
        }).then((response) => {
            this.setState({ chooseCreditcard: response.data.cardList, loading: 0 });
        });
    }

    displayDebitCard() {

        // this.setState({loading: 1});
        let chooseMethod = document.querySelector('.choose-method');
        let chooseDebitcard = document.querySelector('.choose-debitcard');
        chooseMethod.classList.add('d-none');
        chooseDebitcard.classList.remove('d-none');

        /* axios.post('https://www.pagtel.com.br/Hub360Correios/v2/GetCard', {
        transactionId: moment().add('3', 'seconds').unix(),
        MSISDN: this.state.clientInfo.number
        }).then((response) => {
            this.setState({chooseCreditcard: response.data.cardList, loading: 0 });
        }); */
    }

    displayCancelDebitCard() {

        // this.setState({loading: 1});
        let chooseMethod = document.querySelector('.choose-method');
        let chooseDebitcard = document.querySelector('.choose-debitcard');
        chooseMethod.classList.remove('d-none');
        chooseDebitcard.classList.add('d-none');
    }

    async changePage(page) {

        this.setState({ loading: 1 });
        switch (page) {
            case 'chooseNumber':

                let bundleInfo = localStorage.getItem('BundleInfo');
                let homeHistory = localStorage.getItem('homeHistory');


                if (bundleInfo && homeHistory) {
                    bundleInfo = JSON.parse(bundleInfo);
                    homeHistory = JSON.parse(homeHistory);
                    this.setState({
                        chooseNumber: {
                            ...this.state.chooseNumber,
                            bundleInfo: bundleInfo,
                            homeHistory: homeHistory.infoDetails,

                        },
                        loading: 0
                    });
                } else {

                    await axios.post('https://www.pagtel.com.br/Hub360Correios/v2/BundleInfo', {
                        transactionId: transactionID('AAX'),
                        msisdn: this.state.clientInfo.number
                    }).then((response) => {
                        this.setState({ chooseNumber: { ...this.state.chooseNumber, bundleInfo: response.data } });
                    });

                    await axios.post('https://www.pagtel.com.br/Hub360Correios/v2/homeHistory', {
                        transactionId: transactionID('AAY'),
                        msisdn: this.state.clientInfo.number
                    }).then((response) => {
                        this.setState({ chooseNumber: { ...this.state.chooseNumber, homeHistory: response.data.infoDetails }, loading: 0 })
                    });

                }

                if (window.location.hash === '#troca-plano') {

                    setTimeout(() => {
                        this.steps(1);
                        this.getValues();
                        this.setState({
                            loading: 1
                        });
                    }, 100);
                }

                break;
        }
    }


    handleInputChange = ({ target }) => {
        //console.log(target.name);
        if (target.name === 'number') {
            target.value = formatCreditCardNumber(target.value);
        } else if (target.name === 'expiry') {
            target.value = formatExpirationDate(target.value);
        } else if (target.name === 'cvv') {
            target.value = formatCVC(target.value);
        }

        this.setState({ cardData: { ...this.state.cardData, [target.name]: target.value } });

        //console.log(this.state.cardData);
    };

    handleInputFocus = ({ target }) => {
        this.setState({
            focused: target.name,
        });
    };

    getNodeindex(elm) {

        return [...elm.parentNode.children].findIndex(c => c == elm)
        // or
        return [...elm.parentNode.children].indexOf(elm)
    }

    backStep(element, step) {

        if (step < 0) {
            this.setState({ redirect: true });
            return false;
        }

        //if(currentStep >= stepProgress.length) stepProgress[stepProgress.length - 1].classList.add('current');

        let currentStep = document.querySelector(
            ".content-recharge-step ol.progressbar li.current"
        );

        if (currentStep === null) {
            let LastCurrentStep = document.querySelectorAll(
                ".content-recharge-step ol.progressbar li:last-child"
            )[0];
            //LastCurrentStep.classList.add('current');
            currentStep = LastCurrentStep;
        }

        if (this.getNodeindex(currentStep) >= step) {
            this.steps(step);
        }
    }

    steps(step) {
        this.displayCreditCard_2();
        this.displayDeditCard_2();

        let stepProgress = document.querySelectorAll(
            ".content-recharge-step ol.progressbar li"
        );
        let containerStep = document.querySelectorAll(".containerRecharge .step");


        containerStep.forEach((step) => {
            step.classList.remove("current");
        });

        stepProgress.forEach((step) => {
            step.classList.remove("current");
        });

        let currentStep = this.state.currentStep;

        switch (step) {
            case 'next':
                if (this.state.currentStep < 3)
                    currentStep = this.state.currentStep + 1;
                this.setState({
                    currentStep: currentStep
                });
                break;
            case 'previous':
                if (this.state.currentStep > 0)
                    currentStep = this.state.currentStep - 1;
                this.setState({
                    currentStep: this.state.currentStep - 1
                });
                break;
            default:
                if (!isNaN(step)) {

                    currentStep = step;
                    this.resetDisplayPaymentMethod();
                    switch (step) {
                        case 0:
                            this.setState({
                                currentStep: step,
                                createRecharge: {
                                    ...this.state.createRecharge,
                                    number: 0,
                                    amount: 0,
                                    bundleId: '',
                                    paymentLastNumber: '',
                                    paymentFlag: '',

                                }
                            });
                            break;
                        case 1:
                            this.setState({
                                currentStep: step,
                                createRecharge: {
                                    ...this.state.createRecharge,
                                    amount: 0,
                                    paymentId: '',
                                    paymentLastNumber: '',
                                    paymentFlag: '',
                                }
                            });
                            break;
                        case 2:
                            this.getValues();
                            this.setState({
                                currentStep: step,
                                createRecharge: {
                                    ...this.state.createRecharge,
                                    paymentId: '',
                                    paymentLastNumber: '',
                                    paymentFlag: '',
                                }
                            });
                            break;
                    }



                }

                break;

        }

        containerStep.forEach((step, key) => {
            if (key === currentStep) step.classList.add("current");
        });

        stepProgress.forEach((step, key) => {
            if (key === currentStep) step.classList.add("current");
        });


    }

    changeLastRecharge(value) {

        let value1, value2
        switch (value) {
            case 'number':
                break;

            case 'amount':

                this.getValues();
                break;
        }

        value1 = document.querySelector(`.recharge-change-${value}-text`);
        value2 = document.querySelector(`.recharge-change-${value}-input`);

        value1.classList.add('d-none');
        value2.classList.remove('d-none');



    }

    fastRecharge() {

        let number = this.state.lastRecharge.number;
        let amount = document.querySelector('.recharge-change-amount-input').value;

        amount = typeof amount === 'undefined' || amount === 0 || amount === '' ? this.state.lastRecharge.amount.replace('.', '') : amount;


        this.setState({
            createRecharge: {
                ...this.state.createRecharge,
                number: '55' + number,
                amount: amount
            }
        });

        this.changePage('chooseNumber');
        setTimeout(() => { this.steps(2) }, 100);

    }

    handlePaymentByPix() {
        this.setState({ loading: 1 });
        let self_ = this;
        this.resetDisplayPaymentMethod()
        axios
            // .post("https://www.pagtel.com.br/hub360/homologacao/v2/recharge", {
            .post("https://www.pagtel.com.br/Hub360Correios/v1/bundleBuy", {
                transactionId: transactionID("ACI"),
                MSISDN: this.state.clientInfo.number,
                SMSISDN: this.state.createRecharge.number,
                paymentType: this.state.createRecharge.paymentType,
                paymentId: this.state.createRecharge.paymentId,
                Value: this.state.createRecharge.amount,
                bundleId: this.state.createRecharge.bundleId,
                // Value: 1,
                cvv: this.state.createRecharge.cvv,
                program: this.state.createRecharge.scheduledRecharge,
            })
            .then((response) => {
                this.setState({ loading: 0 });
                switch (response.data.code) {
                    case "P00":
                        // Swal.fire({
                        //   title: "Sucesso",
                        //   text: "Sua recarga foi realizada com sucesso. Após o pagamento do Pix em alguns minutos seus créditos estarão disponíveis!",
                        //   type: "success",
                        // }).then(() => {
                        // self_.setState({ 
                        //   ...this.state.createRecharge,

                        // });

                        localStorage.setItem("@pix-data-recharge", JSON.stringify("true"))
                        // localStorage.setItem("@pix-data", JSON.stringify(response.data))

                        this.setState((state) => ({
                            ...this.state.createRecharge,
                            pixOpen: true,
                            pixResponseData: {
                                ...response.data
                            }
                        }));


                        //  if(response.data){
                        //     const storageData = {
                        //     createRecharge : {
                        //     ...this.state.createRecharge,
                        //     },
                        //     pixResponseData: {
                        //       ...response.data,
                        //     }
                        //   }

                        //    localStorage.setItem('@pix-recharge' , JSON.stringify(storageData));
                        //  }

                        let displayCreditCard = document.querySelector(".purchase-resume");
                        let contentRecharge = document.querySelector(".content-recharge-step");
                        let displayContentRechargeManager = document.querySelector(".content-recharge-manager");
                        if (displayCreditCard) displayCreditCard.classList.add("d-none");
                        if (contentRecharge) contentRecharge.classList.add("d-none");
                        if (displayContentRechargeManager) displayContentRechargeManager.classList.add("d-none");
                        // });  

                        break;
                    case "D01":
                        window.location.href = response.data.authenticationUrl;
                        break;

                    default:
                        Swal.fire({
                            title: "Erro!",
                            text: response.data.msg,
                            type: "error",
                        });

                        this.setState({
                            loading: 0,
                            createRecharge: { ...this.state.createRecharge, cvv: 0 },
                        });

                        break;
                }
            })
            .catch((res) => {
                Swal.fire({
                    title: "Erro!",
                    text: "Erro ao finalizar a recarga por Pix!",
                    type: "error",
                });
                this.setState({ loading: 0 });
            });
    }

    choosePixPaymentMethod(info) {
        this.setState({
            createRecharge: {
                ...this.state.createRecharge,
                paymentType: `P`,
            },
            loading: 0,
        });
        this.resetDisplayPaymentMethod();
        this.steps("next");
    }

    sendRecharge() {
        if (this.state.createRecharge.paymentType === "P") {
            return this.handlePaymentByPix();
        }

        if ((this.state.createRecharge.paymentType === 'C' || this.state.createRecharge.paymentType === 'D') && this.state.createRecharge.cvv === 0) {
            MySwal.fire({
                title: 'Digite o CVV',
                //html: ('<input type="text" maxlength="4" className="cvv-input"  />'),
                input: 'text',
                confirmButtonColor: '#05416B',
                inputAttributes: {
                    autocapitalize: 'off',
                    maxlength: 4,
                    type: 'number'
                },
                onOpen: (el) => {
                    el.addEventListener('keyup', function (e) {
                        e.target.value = e.target.value.toLocaleLowerCase().replace(/([a-z]+)/g, '');
                    });
                },
                showCancelButton: false,
                confirmButtonText: 'OK',

            }).then((result) => {

                if (result.value > 0) {
                    this.setState({
                        createRecharge:
                        {
                            ...this.state.createRecharge,
                            cvv: result.value
                        }
                    });

                    setTimeout(() => { this.sendRecharge() }, 500);
                }
            });
            return false;
        }

        this.setState({ loading: 1 });
        let self_ = this;
        axios.post('https://www.pagtel.com.br/Hub360Correios/v1/bundleBuy', {
            transactionId: transactionID('AAZ'),
            MSISDN: this.state.clientInfo.number,
            SMSISDN: this.state.createRecharge.number,
            paymentType: this.state.createRecharge.paymentType,
            paymentId: this.state.createRecharge.paymentId,
            bundleId: this.state.createRecharge.bundleId,
            cvv: this.state.createRecharge.cvv
        }).then((response) => {
            this.setState({ loading: 0 });

            switch (response.data.code) {
                case 'P00':
                    Swal.fire({
                        title: 'Sucesso',
                        text: "Sua compra foi feita com sucesso!",
                        imageUrl: successIcon,
                        confirmButtonColor: '#05416B'
                    }).then(() => {
                        self_.setState({ redirect: true });
                    });

                    break;
                case 'D01':
                    window.location.href = response.data.authenticationUrl;
                    break;

                default:
                    Swal.fire({
                        title: 'Erro!',
                        text: response.data.msg,
                        type: 'error'
                    });

                    this.setState({ loading: 0, createRecharge: { ...this.state.createRecharge, cvv: 0 } })

                    break;

            }

        }).catch(res => {
            Swal.fire({
                title: 'Erro!',
                text: "Erro ao carregar os cartões!",
                type: 'error'
            })
            this.setState({ loading: 0 });
        });

    }

    displayAnotherNumber() {
        document.querySelector('.choose-self-number').classList.add('d-none');
        document.querySelector('.choose-another-number-container').classList.remove('d-none');
    }

    backBtn = (e) => {
        e.preventDefault();

        if (this.state.currentStep === 0) {
            this.setState({ redirect: true });
        }
        else {
            this.steps("previous");
        }

    }


    render() {


        if (this.state.redirect) {
            return <Redirect to={{
                pathname: "/home"
            }} />
        }

        return (
            <div>
                <div className="rechargeSteps">

                    <MemoryRouter>
                        <Route exact path="/">
                            <div className="content-recharge-step" >
                                <div className="btn-back back-recarga-btn"><a onClick={this.backBtn} href="#"> Voltar </a></div>
                                <ol className="progressbar">
                                    <li className="current" onClick={(e) => { this.backStep(e, 0) }}>
                                        <p>{this.state.createRecharge.number === 0 ? 'Número' : this.state.createRecharge.number}</p>
                                    </li>
                                    <li className="" onClick={(e) => { this.backStep(e, 1) }}>
                                        <p>{this.state.createRecharge.amount === 0 ? 'Valor' : this.formatReal(this.state.createRecharge.amount)}</p>
                                    </li>
                                    <li className="" onClick={(e) => { this.backStep(e, 2) }}>
                                        <p>{this.state.createRecharge.paymentFlag === '' ? 'Pagamento' : `${this.state.createRecharge.paymentFlag} ${this.state.createRecharge.paymentLastNumber}`}  </p>
                                    </li>
                                </ol>
                                <div className="containerRecharge">

                                    <div className="choose-number-container step current" >
                                        <h2>Para qual número você deseja contratar?</h2>
                                        <div className="choose-self-number">
                                            <ul className="choose-number-box">
                                                <li>
                                                    <h1>Meu número</h1>
                                                    <small>{this.formatPhone(this.state.clientInfo.number)}</small>

                                                    {/* <p className="choose-number-plan">{this.state.chooseNumber.bundleInfo.bundleName}</p> */}

                                                    {/* <div className="choose-number-plan-container">
                                                    { 
                                                    
                                                        this.state.chooseNumber.homeHistory.map((response, key) => 
                                                            {

                                                                let output;

                                                                switch(response.type){
                                                                    case 'VOICE':
                                                                        output = <div className="choose-number-plan-item" key={key}>
                                                                                    <h5><i className="choose-number-plan-icon bg-color-info"></i>TELEFONE</h5>
                                                                                    <p><strong>{response.details.used}M</strong> de {response.details.total}m</p>
                                                                                </div>;
                                                                        break;
                                                                    case 'SMS':
                                                                            output = <div className="choose-number-plan-item" key={key}>
                                                                                        <h5><i className="choose-number-plan-icon bg-color-success"></i>SMS</h5>
                                                                                        <p><strong>{response.details.used}</strong> de {response.details.total}</p>
                                                                                    </div>;
                                                                            break;
                                                                    case 'DATA':
                                                                            output = <div className="choose-number-plan-item" key={key}>
                                                                                        <h5><i className="choose-number-plan-icon bg-color-danger"></i>INTERNET</h5>
                                                                                        <p><strong>{response.details.used}GB</strong> de {response.details.total}GB</p>
                                                                                        </div>;
                                                                            break;
                                                                }
                                                                return (output);
                                                            }
                                                        ) 
                                                    }
                                                    
                                                </div> */}
                                                    <div className="arrow-icon init-troca-de-plano" href="#" onClick={() => { this.chooseNumber(this.state.clientInfo.number) }}></div>
                                                </li>
                                            </ul>
                                            {/* <p className="choose-number-new-number"><i className="choose-number-plan-icon icon-plus"></i> Adicionar novo número</p> */}
                                            {/* <p className="choose-number-new-number btn-choose-another-number" onClick={() => {this.displayAnotherNumber()} }>Recarregar outro número</p> */}
                                        </div>
                                        <div className="choose-another-number-container d-none">
                                            <ul className="choose-number-box">
                                                <li>
                                                    <h1>Outro Número</h1>

                                                    <NumberFormat
                                                        format="(##) #####-####"
                                                        placeholder="(11) 99999-9999"
                                                        className="choose-another-number-input"
                                                        onValueChange={(values) => {
                                                            const { value } = values;
                                                            this.setState({
                                                                createRecharge: {
                                                                    ...this.state.createRecharge,
                                                                    number: '55' + value
                                                                }
                                                            });
                                                        }}
                                                    />

                                                    <div className="arrow-icon" href="#" onClick={() => {


                                                        if (this.state.createRecharge.number === 0 || this.state.createRecharge.number.length < 13) {
                                                            Swal.fire({
                                                                title: 'Erro!',
                                                                text: "Digite corretamente o número para recarregar!",
                                                                type: 'error'
                                                            })
                                                            // document.querySelector('.choose-another-number-input').focus();
                                                            return false;
                                                        }
                                                        this.chooseNumber(this.state.createRecharge.number)

                                                    }}></div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="choose-amount-container step " >
                                        <h1>Selecione o valor</h1>
                                        <h3><strong>PACOTE ADICIONAL</strong></h3>
                                        <p>(VALIDADE 10 DIAS)</p>
                                        <ul className="select-amount">
                                            {
                                                this.state.chooseAmount.map((response, key) => {
                                                    return <li className="cursor-pointer" key={key} onClick={() => { this.chooseAmount(response.value, response.bundleId, response.note) }} amount={response.value}>
                                                        <img src={response.note} />

                                                        <div className="btn-aderir">RECARREGAR</div>

                                                    </li>
                                                })
                                            }
                                        </ul>
                                    </div>

                                    <div className="choose-payment-method-container step">
                                        <div className="choose-method">
                                            <h2>Selecione a forma de pagamento</h2>
                                            <ul className="select-payment-method ">
                                                <li onClick={() => { this.displayCreditCard() }}>
                                                    <div className="img-select-method">
                                                        <img src={require('../../images/payments/iCredito.png')} />
                                                    </div>
                                                    <div>
                                                        <h4>Crédito</h4>
                                                        <img className="payment-flags" src={require('../../images/payments/flags_credit.svg')} />
                                                    </div>
                                                    <div className="arrow-icon" href="#"></div>
                                                </li>
                                                <li onClick={() => { this.displayDebitCard() }}>
                                                    <div className="img-select-method">
                                                        <img src={require('../../images/payments/iDebito.png')} />
                                                    </div>
                                                    <div>
                                                        <h4>Débito</h4>
                                                        <img className="payment-flags" src={require('../../images/payments/flags_debit.svg')} />
                                                    </div>
                                                    <div className="arrow-icon" href="#" ></div>
                                                </li>
                                                <li
                                                    onClick={() => {
                                                        this.choosePixPaymentMethod();
                                                    }}
                                                >
                                                    <div style={{ display: "flex", alignItems: 'center' }}>
                                                        <div className="img-select-method">
                                                            <img
                                                                src={require("../../images/logo-pix-icone-256.png")}
                                                            />
                                                        </div>
                                                        <div style={{ marginLeft: '25px' }}>
                                                            <h4>Pagamento via Pix</h4>
                                                        </div>
                                                    </div>
                                                    <div className="arrow-icon" href="#"></div>
                                                </li>
                                            </ul>
                                        </div>


                                        <div className="d-none choose-creditcard">
                                            <h2>Selecione o cartão de crédito</h2>
                                            <ul className="select-payment-method">
                                                {this.state.chooseCreditcard === null ?

                                                    <li>
                                                        <h3>Nenhum cartão cadastrado!</h3>
                                                    </li>

                                                    :
                                                    this.state.chooseCreditcard.map((response, key) => {
                                                        return (
                                                            <li onClick={() => { this.choosePaymentMethod(response) }} key={key}>
                                                                <div className="img-select-method">
                                                                    <img src={require(`../../images/payments/${response.flag.toLowerCase()}.svg`)} />
                                                                </div>
                                                                <div>
                                                                    <h4>Cartão {response.flag}</h4>
                                                                    <p>Final {response.digFour}</p>
                                                                </div>
                                                                <div className="arrow-icon" href="#" ></div>
                                                            </li>
                                                        );
                                                    })
                                                }
                                                {/* <li>
                                                <div className="img-select-method">
                                                    <img src={require('../../images/payments/mastercard.svg')} />
                                                </div>
                                                <div>
                                                    <h4>Cartão Master</h4>
                                                    <p>Final 9019</p>
                                                </div>
                                                <div className="arrow-icon" href="#" ></div>
                                            </li>
                                            <li>
                                                <div className="img-select-method">
                                                    <img src={require('../../images/payments/visa.svg')} />
                                                </div>
                                                <div>
                                                    <h4>Cartão Visa</h4>
                                                    <p>Final 9019</p>
                                                </div>
                                                <div className="arrow-icon" href="#" ></div>
                                            </li> */}
                                            </ul>
                                            <p className="choose-number-new-number cursor-pointer" onClick={() => { this.displayAddCreditCard() }}><i className="choose-number-plan-icon icon-plus"></i> Adicionar novo cartão</p>
                                        </div>


                                        <div className="display-add-card card-container d-none">
                                            <h2>Novo Cartão de crédito</h2>
                                            <div className="card-content">
                                                <div className="content-payment-body-info">
                                                    <form>
                                                        <label>Número do cartão</label>
                                                        <NumberFormat
                                                            type="text"
                                                            name="number"
                                                            placeholder="5555 **** **** 7181"
                                                            required
                                                            onValueChange={(values) => {
                                                                const { value } = values;
                                                                this.setState({ cardData: { ...this.state.cardData, number: value } });
                                                            }}
                                                            onFocus={this.handleInputFocus}
                                                            format="####.####.####.####"
                                                        />

                                                        <label>Nome titular</label>
                                                        <input
                                                            type="text"
                                                            name="name"
                                                            placeholder="José da Silva"
                                                            required
                                                            onChange={this.handleInputChange}
                                                            onFocus={this.handleInputFocus} />

                                                        <div className="both-info">
                                                            <div>

                                                                <label>Data de vencimento</label>
                                                                <NumberFormat
                                                                    type="text"
                                                                    name="expiry"
                                                                    placeholder="04/21"
                                                                    pattern="\d\d/\d\d"
                                                                    required
                                                                    onValueChange={(values) => {
                                                                        const { value } = values;
                                                                        this.setState({ cardData: { ...this.state.cardData, expiry: value } });
                                                                    }}
                                                                    onFocus={this.handleInputFocus}
                                                                    format="##/##"
                                                                />

                                                            </div>
                                                            <div>

                                                                <label>CVV</label>
                                                                <input
                                                                    type="text"
                                                                    name="cvv"
                                                                    placeholder="***"
                                                                    pattern="\d{3,4}"
                                                                    required
                                                                    onChange={this.handleInputChange}
                                                                    onFocus={this.handleInputFocus} />

                                                            </div>
                                                        </div>

                                                        <label>CPF</label>
                                                        <NumberFormat
                                                            value={this.state.cardData.cpf}
                                                            placeholder="123.456.789-10"
                                                            onValueChange={(values) => {
                                                                const { value } = values;
                                                                if (value.length === 11 && !this.validCpf(value)) {
                                                                    Swal.fire({
                                                                        title: 'Erro!',
                                                                        text: "CPF inválido!",
                                                                        type: 'error',
                                                                        icon: 'error'
                                                                    })
                                                                    //this.setState({loading: 0}); 
                                                                }
                                                                this.setState({ cardData: { ...this.state.cardData, cpf: value } });
                                                                // console.log(this.state.cardData);
                                                            }}
                                                            format="###.###.###-##"
                                                        />

                                                    </form>
                                                </div>

                                                <div className="content-payment-body-card">
                                                    <Card
                                                        number={this.state.cardData.number}
                                                        name={this.state.cardData.name}
                                                        expiry={this.state.cardData.expiry}
                                                        cvc={this.state.cardData.cvv}
                                                        focused={this.state.focused}
                                                        callback={this.handleCallback}
                                                    />
                                                </div>
                                            </div>
                                            <div className="container-btn-add">
                                                <button className="btn btn-cancel" onClick={() => { this.displayCancelCreditCard() }}>Cancelar</button>
                                                <button className="btn btn-success" onClick={() => { this.addCreditcard() }}>Salvar</button>
                                            </div>
                                        </div>

                                        <div className="choose-debitcard card-container d-none">
                                            <h2>Cartão de débito</h2>
                                            <div className="card-content">
                                                <div className="content-payment-body-info">
                                                    <form>
                                                        <label>Número do cartão</label>
                                                        <NumberFormat
                                                            type="text"
                                                            name="number"
                                                            placeholder="5555 **** **** 7181"
                                                            required
                                                            onValueChange={(values) => {
                                                                const { value } = values;
                                                                this.setState({ cardData: { ...this.state.cardData, number: value } });
                                                            }}
                                                            onFocus={this.handleInputFocus}
                                                            format="####.####.####.####"
                                                        />

                                                        <label>Nome titular</label>
                                                        <input
                                                            type="text"
                                                            name="name"
                                                            placeholder="José da Silva"
                                                            required
                                                            onChange={this.handleInputChange}
                                                            onFocus={this.handleInputFocus} />

                                                        <div className="both-info">
                                                            <div>

                                                                <label>Data de vencimento</label>
                                                                <NumberFormat
                                                                    type="text"
                                                                    name="expiry"
                                                                    placeholder="04/21"
                                                                    pattern="\d\d/\d\d"
                                                                    required
                                                                    onValueChange={(values) => {
                                                                        const { value } = values;
                                                                        this.setState({ cardData: { ...this.state.cardData, expiry: value } });
                                                                    }}
                                                                    onFocus={this.handleInputFocus}
                                                                    format="##/##"
                                                                />

                                                            </div>
                                                            <div>

                                                                <label>CVV</label>
                                                                <input
                                                                    type="text"
                                                                    name="cvv"
                                                                    placeholder="***"
                                                                    pattern="\d{3,4}"
                                                                    required
                                                                    onChange={this.handleInputChange}
                                                                    onFocus={this.handleInputFocus} />

                                                            </div>
                                                        </div>

                                                        <label>CPF</label>
                                                        <NumberFormat
                                                            value={this.state.cardData.cpf}
                                                            placeholder="123.456.789-10"
                                                            onValueChange={(values) => {
                                                                const { value } = values;
                                                                if (value.length === 11 && !this.validCpf(value)) {
                                                                    Swal.fire({
                                                                        title: 'Erro!',
                                                                        text: "CPF inválido!",
                                                                        type: 'error',
                                                                        icon: 'error'
                                                                    })
                                                                    //this.setState({loading: 0}); 
                                                                }
                                                                this.setState({ cardData: { ...this.state.cardData, cpf: value } });
                                                                // console.log(this.state.cardData);
                                                            }}
                                                            format="###.###.###-##"
                                                        />

                                                    </form>
                                                </div>

                                                <div className="content-payment-body-card">
                                                    <Card
                                                        number={this.state.cardData.number}
                                                        name={this.state.cardData.name}
                                                        expiry={this.state.cardData.expiry}
                                                        cvc={this.state.cardData.cvv}
                                                        focused={this.state.focused}
                                                        callback={this.handleCallback}
                                                    />
                                                </div>
                                            </div>
                                            <div className="container-btn-add">
                                                <button className="btn btn-cancel" onClick={() => { this.displayCancelDebitCard() }}>Cancelar</button>
                                                <button className="btn btn-success" onClick={() => { this.addDebitcard() }}>Salvar</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="purchase-resume step">
                                        {/* <h2>Resumo</h2> */}

                                        <ul className="purchase-resume-container">
                                            <li>
                                                <div className="recharge-change-number-container">
                                                    <small>Valor</small>
                                                    <a href="#" className="recharge-change-number" onClick={() => { this.steps(1) }}>Trocar</a>
                                                </div>
                                                <div className="d-flex recharge-change-number-display">
                                                    {this.state.createRecharge.amount !== 0 &&

                                                        <div className="list-details">
                                                            {/* {this.state.createRecharge.details.map((response, key) => {
                                                                return <li className="list-detail-li" key={key}>
                                                                    <i><img src={response.icone} /></i>
                                                                    <div className="list-detail-li-block">
                                                                        <h4>{response.title}</h4>
                                                                        <p>{response.description}</p>
                                                                    </div>
                                                                </li>
                                                            })} */}
                                                        </div>

                                                    }
                                                </div>
                                            </li>
                                            <li>
                                                <div className="recharge-change-number-container">
                                                    <small>Número</small>
                                                    <a href="#" className="recharge-change-number" onClick={() => { this.steps(0) }}>Trocar</a>
                                                </div>
                                                <p>{this.formatPhone(this.state.createRecharge.number)}</p>
                                            </li>
                                            <li>
                                                <div className="recharge-change-number-container">
                                                    <small>Pagamento</small>
                                                    <a href="#" className="recharge-change-number" onClick={() => { this.steps(2) }}>Trocar</a>
                                                </div>

                                                <div className="d-flex flex-item-align-center">
                                                    <div>
                                                        {
                                                            typeof this.state.createRecharge.paymentFlag !== 'undefined'
                                                            && this.state.createRecharge.paymentFlag === '' ||
                                                            <img className="resume-payment-flag" src={require(`../../images/payments/${this.state.createRecharge.paymentFlag.toLocaleLowerCase()}.svg`)} />
                                                        }
                                                    </div>
                                                    <div>
                                                        Final {this.state.createRecharge.paymentLastNumber}
                                                    </div>
                                                </div>


                                            </li>
                                            <li>
                                                <div className="recharge-change-number-container">
                                                    <small>Total</small>
                                                    <a href="#" className="recharge-amount-total color-success">{this.formatReal(this.state.createRecharge.amount)}</a>
                                                </div>
                                            </li>
                                        </ul>

                                        <br />

                                        <button className="btn btn-success" onClick={() => { this.sendRecharge() }} style={{ margin: '0 auto' }}>CONFIRMAR</button>

                                    </div>


                                </div>
                            </div>
                        </Route>
                    </MemoryRouter>

                </div>
                <Loading loading={this.state.loading} />
            </div>
        );
    }

}

export default AdditionalPackageStep